<template>
   <div class="threecategroy">
    <div class="" style="overflow-x: auto;">
      <div class="tab">
        <div class="tabitem" @click="tabItem(item.categoryId)"  :class="{'tabitemactive':categoryId==item.categoryId}" v-for="item,index in list">
        {{item.categoryName}}
        <span v-if="index<list.length-1" style="margin: 0 10px;color: #ccc;">|</span>
        </div>
      </div>
    </div>
   </div>
</template>

<script>
  import bus from '../assets/utils/eventBus.js';
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
          data:'',
          list:[],
          categoryId:''
      }
    },
    methods:{
      getData(){
        let data={
            parentId:window.sessionStorage.twoCategoryId
        };
        this.$axios.get(this.$common.categoryListSon_url,{params:data}).then((res)=>{
              console.log(res)
              if(res.data.code==1){
                  this.list=res.data.data;
                  if(this.list.length>0){
                 //   this.categoryId=res.data.data[0].categoryId
                  }
                  this.getMyCategory()
              }
              else {

              }
        })
      },
      tabItem(categoryId){
        this.categoryId = categoryId;

       let data=new FormData();
                    data.append('oneCategoryId',window.sessionStorage.oneCategoryId);
                    data.append('twoCategoryId',window.sessionStorage.twoCategoryId);
                    data.append('threeCategoryId',this.categoryId);
        this.$axios.post(this.$common.login_accountCategory,data).then((res)=>{
              console.log(res)
              if(res.data.code==1){

                 this.$emit('initData')

                  this.getIsBuy()
              }
              else {

              }
        })
      },
      getIsBuy(){
        let data={
          oneCategoryId:window.sessionStorage.oneCategoryId,
          twoCategoryId:window.sessionStorage.twoCategoryId,
          threeCategoryId:this.categoryId
        };
        this.$axios.get(this.$common.login_bugTag,{params:data}).then((res)=>{
              console.log(res)
              if(res.data.code==1){

                  bus.$emit('bugTag',res.data.data.bugTag)

              }
              else {

              }
        })
      },
      getMyCategory(){
        this.$axios.get(this.$common.login_selectCategory).then((res)=>{
              console.log(res)
              if(res.data.code==1){
                 this.categoryId = res.data.data.threeCategoryId;
                 this.getIsBuy();

              }
              else {

              }
        })
      }
    },
    created(){
      this.getData()
    }
  }
</script>

<style scoped>
  .tab {
    display: flex;
    margin-bottom: 15px;
  }
  .tabitem {
    font-size: 16px;
    cursor: pointer;
    white-space: nowrap;
  }
  .tabitemactive {
    color: #4fa7ff;
  }
</style>



// WEBPACK FOOTER //
// src/components/threecategory.vue